export default "__VITE_PUBLIC_ASSET__7762e6af__"